import { render, staticRenderFns } from "./CompaniesEditPage.vue?vue&type=template&id=35845a10"
import script from "./CompaniesEditPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports